import {
  gql,
  sendAPIRequest,
  simplifyGraphQLJSON,
  insertGraphQLFragments,
} from './GraphQLClient';

import {
  fragmentTask,
  fragmentRoomFull,
  fragmentConnectedRoom,
  serializeRoomFull,
  serializeConnectedRoom,
  serializeTask,
} from './serializers';


export async function createTaskInRoom(roomId, reminderType, timestamp, text) {
  const query = gql`
    mutation ($roomId: ID!, $reminderType: ID!, $timestamp: DateTime!, $text: String) {
      setReminder(roomId: $roomId, typeId: $reminderType, timestamp: $timestamp, text: $text) {
        id
      }
    }
  `;
  return sendAPIRequest(query, {
    roomId,
    reminderType,
    timestamp,
    text,
  });
}


export async function closeCase(roomId, tags, isResolved) {
  const query = gql`
    mutation ($roomId: ID!, $tags: [ID], $isResolved: Boolean) {
      finishCase(roomId: $roomId, tags: $tags, isResolved: $isResolved) {
        id
      }
    }
  `;
  return sendAPIRequest(query, { roomId, tags, isResolved });
}


export function getReminderTypesByCompanyId(companyId){
  const query = gql`
    query ($companyId: Uuid!) {
      reminderTypes(companyId: $companyId) {
        id
        title
      }
    }
  `;
  return sendAPIRequest(query, { companyId });
}

export function getReasonTypesByCompanyId(companyId){
  const query = gql`
    query ($companyId: Uuid!) {
      finishTags(companyId: $companyId) {
        id
        title
      }
    }
  `;
  return sendAPIRequest(query, { companyId });
}


export function requestScreenshot(roomId){
  const query = gql`
    mutation ($roomId: ID!) {
      requestScreenshot(roomId: $roomId) {
        id
      }
    }
  `;
  return sendAPIRequest(query, { roomId });
}


export function linkJiraTaskWithRoom(roomId, jiraId){
  const query = gql`
    mutation ($roomId: ID!, $jiraId: ID!) {
      addRoomTask(roomId: $roomId, providerId: $jiraId, provider: JIRA) {
        id
      }
    }
  `;
  return sendAPIRequest(query, { roomId, jiraId });
}

export function searchJiraTasks(companyId, searchQuery, isLinkedWithIssue, limit = 10){
  const query = insertGraphQLFragments(gql`
    query ($companyId: Uuid!, $searchQuery: String!, $limit: Int!, $isLinkedWithIssue: Boolean) {
      searchTask(provider: JIRA, companyId: $companyId, query: $searchQuery, first: $limit, isLinkedWithIssue: $isLinkedWithIssue) {
        edges {
          cursor
          node { ...fragmentTask }
        }
      }
    }
  `, { fragmentTask });
  const variables = {
    companyId,
    searchQuery,
    isLinkedWithIssue,
    limit,
  };
  return sendAPIRequest(query, variables).then(tasks => {
    return simplifyGraphQLJSON(tasks).map(serializeTask);
  });
}


export function getTaskByJiraId(companyId, jiraId){
  const query = insertGraphQLFragments(gql`
    query ($companyId: Uuid!, $jiraId: ID!) {
      task(companyId: $companyId, providerId: $jiraId, provider: JIRA) {
        ...fragmentTask
      }
    }
  `, { fragmentTask });
  return sendAPIRequest(query, { companyId, jiraId });
}


export function updateRoom(roomId, data){
  const { title, notes } = data || {};
  const query = insertGraphQLFragments(gql`
    mutation ($roomId: ID!, $title: String, $notes: String) {
      updateRoom(roomId: $roomId, title: $title, notes: $notes) {
        ...fragmentRoomFull
      }
    }
  `, { fragmentRoomFull });
  return sendAPIRequest(query, { roomId, title, notes }).then(serializeRoomFull);
}



export function connectRooms(companyId, fromRoomId, toRoomId, toClientId){
  const query = gql`
    mutation ($companyId: Uuid!, $fromRoomId: ID!, $toRoomId: ID!, $toClientId: ID) {
      connectRoom(companyId: $companyId, fromRoomId: $fromRoomId, toRoomId: $toRoomId, toClientId: $toClientId) {
        id
      }
    }
  `;
  const variables = { companyId, fromRoomId, toRoomId, toClientId };
  return sendAPIRequest(query, variables);
}


export function getConnectedRooms(roomId, limit = 100, afterCursor){
  const query = insertGraphQLFragments(gql`
    query ($roomId: ID!, $limit: Int, $afterCursor: String) {
      connectedRooms(roomId: $roomId, first: $limit, after: $afterCursor) {
        edges {
          node { ...fragmentConnectedRoom }
        }
      }
    }
  `, { fragmentConnectedRoom });
  const variables = { roomId, limit, afterCursor };
  return sendAPIRequest(query, variables).then(connectedRooms => {
    return simplifyGraphQLJSON(connectedRooms).map(serializeConnectedRoom);
  });
}


export function disconnectRoom(companyId, connectedRoomId){
  const query = gql`
    mutation ($companyId: Uuid!, $connectedRoomId: ID!) {
      disconnectRoom(companyId: $companyId, connectedRoomId: $connectedRoomId) {
        id
      }
    }
  `;
  return sendAPIRequest(query, { companyId, connectedRoomId });
}
